import React from 'react';
import { MediaQueueTile } from '@cube3/ui/src/Prefabs/MediaQueue/MediaQueueTile';
import Thumbnail from '@cube3/ui/src/thumbnails/Thumbnail';
import { parseUploadState } from '../../../ContentPane/ContentTree/items/parseUploadState';
import ProgressWithText from '@cube3/cubicle/src/core/atoms/ProgressWithText';
import Time from '@cube3/cubicle/src/core/utility/Time';
import { LibraryItemOverlay } from '@cube3/ui/src/library/LibraryItemOverlay';
import { useTogglePauseUpload } from '@cube3/state/src/Hoocs/Uploads/uploadActions';

import fileImage from '@cube3/ui/src/assets/images/Library/file.svg?url';

import { useUploadStatus } from '../../hooks/useUploadStatus';
import { UploadBreadcrumbs } from '../UploadBreadcrumbs';

import { useUploadActions } from '../../hooks/useUploadActions';
import { Shimmer } from '@cube3/cubicle/src/core/atoms/Loader/Shimmer';

export const UploadQueueListItemAssetInProgress = ({ upload, asset }) => {
  const { status, label, progress } = useUploadStatus(upload, asset);
  const uploadState = parseUploadState(asset?.processing_status, upload);

  const { togglePauseUpload } = useTogglePauseUpload(upload?.id);

  const { onClickRemoveUpload, onClickRetryUpload } = useUploadActions({
    upload,
    asset
  });

  return (
    <li style={{ listStyle: 'none' }}>
      <MediaQueueTile
        thumb={
          <LibraryItemOverlay
            front={
              ((asset && uploadState !== 'AssetProcessingStatusComplete') ||
                (upload && !upload.active && upload.progress === 0)) && (
                <ProgressWithText
                  uploadState={uploadState}
                  upload={upload}
                  gridview={false}
                  disabledByUpload={true}
                  canResume={asset && !upload}
                  onClickRetryUpload={onClickRetryUpload}
                  onClickRemoveUpload={onClickRemoveUpload}
                  onClickToggleUploadPausedState={togglePauseUpload}
                  disableTooltip={true}
                />
              )
            }
            back={
              <Thumbnail
                src={upload?.display_image || asset?.display_image || fileImage}
                cover={false}
                ratio="sixteenToNine"
              />
            }
          />
        }
        title={asset?.display_name || upload?.display_name || 'loading'}
        contextRow={<UploadBreadcrumbs asset={asset} />}
        timestampRow={
          ((upload || asset) && (
            <span>
              Last activity{' '}
              <Time date={upload?.updated_at || asset?.updated_at} />
            </span>
          )) || <Shimmer width={120} height={20} />
        }
        status={status}
        statusLabel={label}
        statusProgress={progress}
        onCloseClick={
          (status === 'failed' || status === 'success') && onClickRemoveUpload
        }
      />
    </li>
  );
};
